var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_1eaa1918"]},_vm.$listeners),[_c('div',[_c('div',{class:["picker-demo-title"]},[_vm._v("Config day options:")]),_c('cube-time-picker',{attrs:{"day":(_vm.day)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }